import { Typography } from '@mui/material';
import { styled } from '@mui/material/styles';

export const PopperBoxStyle = styled('div')`
  border: 2;
  padding: 12px;
  border-radius: 8px;
  background-color: ${({ theme }) => theme.palette.white.main};
  box-shadow: 6;
  margin-bottom: 16px;
`;

export const DeviceTitleText = styled(Typography)`
  display: block;
  font-weight: 700;
  color: ${({ theme }) => theme.palette.white['06']};
`;

export const TitleText = styled(Typography)`
  font-weight: 700;
  color: ${({ theme }) => theme.palette.primary['01']};
`;

export const ValueText = styled(Typography)`
  font-weight: 400;
  color: ${({ theme }) => theme.palette.white['06']};
  font-size: 12px;
`;

export const NoConnectionComponent = styled('div')`
  position: absolute;
  top: 80%;
  left: 88%;
  transform: translate(-45%, -55%);
`;

export const ComposeIcon = styled('div')`
  position: relative;
  width: 38px;
  height: 38px;
`;
